module.exports = __webpack_public_path__ + "img/24.b1cdb57b.svg";